<template>
  <div style="width: 100%;height: 100%">
    <p>{{content}}</p>
    <div class="organization-content">
      <div v-if="showTree" class="tree-content">
        <el-tree @node-click="handleNodeClick" node-key="id" ref="tree" highlight-current :data="data" :props="defaultProps"></el-tree>
      </div>
      <div @click="shrinkTree"  class="shrink" :class="{'shrinkMax':shrinkMax,'shrinkMin':shrinkMin}">
        <div :class="{'shrinkLeft':shrinkLeft,'shrinkRight':shrinkRight}"><i :class="elIcon"></i></div>
      </div>
      <div class="org-tree-content">
        <org-tree :pid="pid" :horizontal="false" :show="false"></org-tree>
      </div>
    </div>
  </div>
</template>

<script>
import orgTree from '../../components/orgTree/orgTree'
export default {
  name: "organization",
  components:{
    orgTree
  },
  data() {
    return {
      pid:'',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'orgName'
      },
      orgType:'commander',
      projectInfo:'',
      sectId:'',
      elIcon:'el-icon-caret-right',
      showTree:false,
      shrinkLeft:false,
      shrinkRight:true,
      shrinkMax:false,
      shrinkMin:false,
      resourceId:'',
      content:''
    }
  },
  mounted() {
    this.resourceId = this.$route.query.resourceId
    this.orgType = this.$route.query.orgType
    let projectInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
    if (!!projectInfo) {
      if (!!projectInfo.projectId) {
        this.projectId = projectInfo.projectId;
      }
      if (!!projectInfo.mainSectionId) {
        this.sectId = projectInfo.mainSectionId;
      }
    }
    this.getTableData()
    this.getTreeList()
  },
  methods:{
    // 获取列表
    getTableData() {
      let params = {
        orgName:this.orgName,
        orgType:this.orgType,
        page:1,
        rows:1000,
      }
      this.$axios.get(`/api/checkwork/orgDepartmentBase/getContentList`,{params:params}).then( res => {
        if (res.data.success) {
          this.data = res.data.data.rows
          this.$nextTick(() => {
            this.pid = res.data.data.rows[0].id
            this.$refs.tree.setCurrentKey(this.pid)
          })
        }
      })
    },
    // 收起展开tree
    shrinkTree() {
      if (this.showTree) {
        this.showTree = false
        this.shrinkRight = true
        this.shrinkLeft = false
        this.shrinkMax = false
        this.shrinkMin = true
        this.elIcon = 'el-icon-caret-right'
      } else {
        this.showTree = true
        this.shrinkRight = false
        this.shrinkLeft = true
        this.shrinkMax = true
        this.shrinkMin = false
        this.elIcon = 'el-icon-caret-left'
      }
    },
    handleNodeClick(node) {
      this.pid = node.id
    },
    // 获取list数据
    getTreeList() {
      this.$axios.post(`/api/resource/getResourceListNoPage?parentId=618745284009885696`).then(res => {
        if (res.data.succeed && res.data.data.length > 0) {
          let data = JSON.parse(JSON.stringify(res.data.data))
          data.forEach((item,index) => {
            if (item.resourceId === this.resourceId) {
              this.content = item.description
            }
          })
        }
      })
    }
  },
}
</script>

<style scoped>
.organization-content {
  display: flex;
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  position: relative;
}
p {
  font-size: 16px;
  line-height:30px;
  border-bottom: 1px solid #e5e5e5;
  margin: 0;
  padding: 20px;
}
.shrink {
  position: absolute;
  top: calc(50% - 10px);
}
.shrink:hover {
  cursor: pointer;
}
.shrinkMax {
  left: 284px;
  z-index: 999;
}
.shrinkMin {
  left: 0;
  z-index: 999;
}
.shrinkLeft {
  width: 100%;
  height: 30px;
  background-color: #409eff;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;
  align-items: center;
  color: #ffffff;
  justify-content: center;
}
.shrinkRight {
  width: 100%;
  height: 30px;
  background-color: #409eff;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  align-items: center;
  color: #ffffff;
  justify-content: center;
}
.tree-content {
  border-right: 2px solid #e4e7ed;
  box-sizing: border-box;
  overflow: auto;
  width: 300px;
  padding-top: 10px;
}
.org-tree-content {
  flex: 1;
  padding: 10px 0 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/orgTree/organization.vue